import { client } from '@/api/http';
import { type AxiosRequestConfig, type AxiosResponse, HttpStatusCode } from 'axios';
import type { HipSpineUserPreferencesApiObject } from '@/api/hipSpinePreferences/types';
import { errorDetail } from '@/api/errorDetail';

export async function getHipSpineUserPreferences(
    userId: number,
    config?: AxiosRequestConfig,
): Promise<HipSpineUserPreferencesApiObject | null> {
    const { status, data }: AxiosResponse = await client.get(
        `users/${userId}/hip-spine-user-preferences`,
        config,
    );
    if (status === HttpStatusCode.Ok) {
        return data;
    } else if (status === HttpStatusCode.NotFound) {
        return null;
    }

    throw new Error(`Failed to load hip-spine user preferences${errorDetail(data)}`);
}

export async function putHipSpineUserPreferences(
    userId: number,
    body: HipSpineUserPreferencesApiObject,
    config?: AxiosRequestConfig,
): Promise<void> {
    const { status, data }: AxiosResponse = await client.put(
        `users/${userId}/hip-spine-user-preferences`,
        body,
        config,
    );
    if (status === HttpStatusCode.NoContent) {
        return;
    }

    throw new Error(`Failed to save hip-spine user preferences${errorDetail(data)}`);
}
